import React from "react";
import PaymentBankDoiPage from "./payment-bank-doi-page";
import PaymentMomoDoiPage from "./payment-momo-doi-page";
import PaymentCodeDoiPage from "./payment-code-doi-page";


export default function PaymentDoiPage() {

  return <div>
    <PaymentBankDoiPage/>
    <div className="h-10 bg-[#eef0f3]"/>
    <PaymentMomoDoiPage/>
    <div className="h-10 bg-[#eef0f3]"/>
    <PaymentCodeDoiPage/>
  </div>;
}
